
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import LogicFlowEditor from '@/components/logic-engine/LogicFlowEditor';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Section } from '@/components/ui/section';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useDialogStore } from '@/store/dialogStore';
import { useLogicFlows } from '@/hooks/useLogicFlows';

export default function LogicEngine() {
  const { isOpen, title, content, data, close } = useDialogStore();
  const { loadFlowById } = useLogicFlows();
  
  const handleFlowSelect = async (flowId: string) => {
    const flow = await loadFlowById(flowId);
    // In a production app, we'd use this flow data to update the editor
    close();
  };

  return (
    <div className="container mx-auto py-6">
      <Section>
        <div className="flex justify-between items-center mb-4">
          <div>
            <h1 className="text-2xl font-bold">Logic Engine</h1>
            <p className="text-muted-foreground">
              Build and manage calibration workflows for vehicles
            </p>
          </div>
          <Button>New Workflow</Button>
        </div>
        
        <Tabs defaultValue="editor">
          <TabsList className="mb-4">
            <TabsTrigger value="editor">Flow Editor</TabsTrigger>
            <TabsTrigger value="saved">Saved Flows</TabsTrigger>
          </TabsList>
          
          <TabsContent value="editor">
            <Card>
              <CardHeader>
                <CardTitle>Visual Flow Editor</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="h-[600px] border rounded-md">
                  <LogicFlowEditor />
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="saved">
            <Card>
              <CardHeader>
                <CardTitle>Saved Workflows</CardTitle>
              </CardHeader>
              <CardContent>
                <p>Your saved logic flows will appear here.</p>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </Section>

      {/* Dialog for flow selection */}
      <Dialog open={isOpen} onOpenChange={close}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          {content === 'flows' && data?.flows && (
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {data.flows.map((flow: any) => (
                <Card key={flow.id} className="cursor-pointer hover:bg-muted" onClick={() => handleFlowSelect(flow.id)}>
                  <CardContent className="p-4">
                    <div className="font-medium">{flow.name}</div>
                    <div className="text-sm text-muted-foreground">
                      {flow.manufacturer && `${flow.manufacturer} - `}{flow.vehicle_type || 'Generic flow'}
                    </div>
                    <div className="text-xs text-muted-foreground mt-1">
                      Created: {new Date(flow.created_at).toLocaleDateString()}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
